import React, { Component } from 'react';

class userProile extends Component {
    render() {
        return (
            <div>
                
            </div>
        );
    }
}

export default userProile;



/** WEBPACK FOOTER **
 ** ./src/containers/profile/userProile.js
 **/